import { formValueSelector } from 'redux-form';
import { FLEXIBLE_TICKET } from '../../products';
const formSection = FLEXIBLE_TICKET.name;
const getGraphQlSelection = ({
  state,
  form
}) => {
  var _formData$value;
  const formData = formValueSelector(form)(state, formSection);
  const selectionTraveler = (formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 ? void 0 : _formData$value.flatMap(({
    value
  }) => {
    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue)) {
      return [];
    }
    return value;
  })) || [];
  if (selectionTraveler.length === 0) {
    return null;
  }
  return {
    productId: String(FLEXIBLE_TICKET.id),
    selectionTraveler
  };
};
export default getGraphQlSelection;
//# sourceMappingURL=getGraphQlSelection.js.map